export async function parseCsv(input) {
  let text = input;
  if (typeof File !== "undefined" && input instanceof File) {
    text = await input.text();
  }
  if (typeof text !== "string") return [];
  text = text.replace(/^\uFEFF/, "");
  const rawLines = text.split(/\r?\n/).filter((l) => l.trim().length > 0);
  if (rawLines.length === 0) return [];
  const guessed = guessSeparator(rawLines[0]);
  const sep = guessed ?? ",";
  const headerCells = splitCSVLine(rawLines[0], sep).map((h) =>
    h.trim().toLowerCase()
  );
  const aliasMap = {
    chave: "pixKey",
    key: "pixKey",
    pixkey: "pixKey",
    tipo: "pixKeyType",
    type: "pixKeyType",
    pixkeytype: "pixKeyType",
    valor: "amount",
    value: "amount",
    amount: "amount",
    nome: "name",
    name: "name",
    documento: "doc",
    doc: "doc",
    mensagem: "message",
    message: "message",
  };
  const rows = [];
  for (let i = 1; i < rawLines.length; i++) {
    const line = rawLines[i];
    const cells = splitCSVLine(line, sep);
    const obj = {};
    headerCells.forEach((h, idx) => {
      const key = aliasMap[h] || h;
      let v = (cells[idx] ?? "").trim();
      if (
        (v.startsWith('"') && v.endsWith('"')) ||
        (v.startsWith("'") && v.endsWith("'"))
      ) {
        v = v.slice(1, -1);
      }
      if (key === "amount") {
        if (v && !v.includes(".") && v.includes(",")) {
          v = v.replace(/,/, ".");
        }
      }
      obj[key] = v;
    });
    const hasAny = Object.values(obj).some((x) => String(x).trim() !== "");
    if (hasAny) rows.push(obj);
  }
  return rows;
}

function guessSeparator(headerLine) {
  const commaCount = (headerLine.match(/,/g) || []).length;
  const semiCount = (headerLine.match(/;/g) || []).length;
  if (semiCount > commaCount) return ";";
  if (commaCount > semiCount) return ",";
  const c1 = splitCSVLine(headerLine, ",").length;
  const c2 = splitCSVLine(headerLine, ";").length;
  return c2 > c1 ? ";" : ",";
}

function splitCSVLine(line, sep) {
  const out = [];
  let cur = "";
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      if (inQuotes && line[i + 1] === '"') {
        cur += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (ch === sep && !inQuotes) {
      out.push(cur);
      cur = "";
    } else {
      cur += ch;
    }
  }
  out.push(cur);
  return out;
}

